// ─────────────────────────────────────────────────────────────────────────────
// PaRiTale Wedding — App Configuration
// Edit this file to customise events, colours, and the event schedule.
// ─────────────────────────────────────────────────────────────────────────────

// ── Event list (order controls display order everywhere in the app) ───────────
export const EVENTS = ["Mehendi", "Haldi", "Sangeet", "Wedding", "Reception"];

// ── Colour for each event (badge, filter tab, picker pill) ───────────────────
export const EVENT_COLORS = {
  Mehendi:   { bg: "#E9A318", text: "white" },
  Haldi:     { bg: "#EAB308", text: "white" },
  Sangeet:   { bg: "#8B5CF6", text: "white" },
  Wedding:   { bg: "#D4808E", text: "white" },
  Reception: { bg: "#0D9488", text: "white" },
};

// ── Wedding Event Schedule ────────────────────────────────────────────────────
// The app auto-selects the upload event based on the device's local date/time.
//
// Rules:
//  • date       — "YYYY-MM-DD" (required)
//  • startHour  — 24-hour start (inclusive). Omit for "all day".
//  • endHour    — 24-hour end   (exclusive). Use 24 for midnight.
//
// When two events share a date, give each a startHour/endHour window.
// For events that run past midnight, add a second entry for the next date.
//
// Falls back to the last manually-chosen event (localStorage) or "Wedding".
export const EVENT_SCHEDULE = [
  { event: "Mehendi",   date: "2026-05-01" },
  { event: "Haldi",     date: "2026-05-02", startHour:  8, endHour: 17 },
  { event: "Sangeet",   date: "2026-05-02", startHour: 17, endHour: 24 },
  { event: "Wedding",   date: "2026-05-03", startHour:  3, endHour: 17 },
  { event: "Reception", date: "2026-05-03", startHour: 17, endHour: 24 },
  { event: "Reception", date: "2026-05-04" },
];

// ── Upload prompt text per event ─────────────────────────────────────────────
export const UPLOAD_TEXTS = {
  Mehendi:   "Capture the Mehendi artistry!",
  Haldi:     "Capture the Haldi glow!",
  Sangeet:   "Upload your Sangeet dance moments!",
  Wedding:   "Share the royal wedding moments.",
  Reception: "Upload magical reception memories.",
};

// ── Helpers ───────────────────────────────────────────────────────────────────

/** Returns the event that matches today's date (and current hour if applicable). */
export const getDefaultEvent = () => {
  const now   = new Date();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  const hour  = now.getHours();
  for (const s of EVENT_SCHEDULE) {
    if (s.date !== today) continue;
    if (s.startHour !== undefined) {
      if (hour >= s.startHour && hour < s.endHour) return s.event;
    } else {
      return s.event;
    }
  }
  return localStorage.getItem("weddingEventTag") || "Wedding";
};

/** Formats a Cloudinary ISO date string as a human-readable relative timestamp. */
export const formatTimestamp = (dateStr) => {
  if (!dateStr) return "";
  const date     = new Date(dateStr);
  const now      = new Date();
  const diffDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
  if (diffDays === 0) return "Today";
  if (diffDays === 1) return "Yesterday";
  if (diffDays < 7)  return `${diffDays}d ago`;
  if (diffDays < 30) return `${Math.floor(diffDays / 7)}w ago`;
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
};
